/**
 * Feature flags
 */
export const FEATURE_FLAGS = Object.freeze({
  ENABLE_BANNER: 'REACT_APP_FEATURE_ENABLE_BANNER',
})

/**
 * Checks if the feature identified by the flag is enabled or disabled
 * @param {String} flag
 */
export const isFeatureEnabled = (flag: string, defaultValue = false) => {
  if (typeof flag !== 'string') throw new Error('Feature flag needs to be a string')

  return (process.env[flag] || defaultValue.toString()).toLowerCase() === 'true'
}
